import { Image } from 'theme-ui';

import { Link } from './Link';

export default function Logo({ src, ...rest }) {
  return (
    <Link
      path="/"
      sx={{
        variant: 'links.logo',
        display: ['none', 'flex'],
        cursor: 'pointer',
        mr: 15,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <Image src={src} alt="MeldMoto logo" />
    </Link>
  );
}
